import { Controller } from "stimulus";
export default class extends Controller {
  static targets = ["childCheckbox", "parentCheckbox"];

  initialize() {
    this.firstSelect = null;
  }

  selectAll(e) {
    if (!this.hasParentCheckboxTarget) return;

    this.changeCheckboxChildStatus(e.target.checked);
    this.clearRange();
  }

  changeCheckboxChildStatus(checked) {
    this.childCheckboxTargets.forEach((element) => {
      element.checked = checked;
    });
  }

  rangeSelect(e) {
    if (e.target.checked) {
      if (e.shiftKey) {
        this.checkRange(this.firstSelect, e.target);
      }
      this.firstSelect = e.target;
    } else {
      this.clearRange();
    }
  }

  checkRange(firstSelect, lastSelect) {
    if (!firstSelect || !lastSelect) return;

    const firstSelectIndex = this.childCheckboxTargets.indexOf(firstSelect);
    const lastSelectIndex = this.childCheckboxTargets.indexOf(lastSelect);
    const minIndex =
      firstSelectIndex > lastSelectIndex ? lastSelectIndex : firstSelectIndex;
    const maxIndex =
      firstSelectIndex > lastSelectIndex ? firstSelectIndex : lastSelectIndex;

    this.childCheckboxTargets
      .slice(minIndex, maxIndex + 1)
      .forEach((checkbox) => (checkbox.checked = true));
  }

  disconnect() {
    this.clearRange();
  }

  clearRange() {
    this.firstSelect = null;
  }
}
